// Archivo: src/services/auth.Service.js

// Leer la URL de la API desde la variable de entorno REACT_APP_API_URL
const API_URL = process.env.REACT_APP_API_URL;

export const login = async (email, password) => {
  try {
    const response = await fetch(`${API_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Error en el inicio de sesión');
    }
    return data;
  } catch (error) {
    console.error('Error al conectar con la API:', error);
    throw error;
  }
};

export const forgotPassword = async (dataUser) => {
  try {
    const response = await fetch(`${API_URL}/forgotPassword`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(dataUser),
    });

    // Leer como texto primero porque algunos endpoints responden sin body
    const text = await response.text();
    let data = {};
    try {
      data = text ? JSON.parse(text) : {};
    } catch (err) {
      // respuesta no es JSON, dejamos data como vacío
      data = {};
    }

    if (!response.ok) {
      // Preferir message del body si existe, si no usar el texto o un mensaje genérico
      const message = data.message || text || `Error ${response.status} al enviar el email`;
      throw new Error(message);
    }

    return data;
  } catch (error) {
    console.error('Error en el servicio de forgotPassword:', error);
    throw error;
  }
};

export const resetPassword = async (credentials) => {
  try {
    const response = await fetch(`${API_URL}/resetPassword`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials),
    });

    const text = await response.text();
    let data = {};
    try {
      data = text ? JSON.parse(text) : {};
    } catch (err) {
      data = {};
    }

    if (!response.ok) {
      const message = data.message || text || `Error ${response.status} al restablecer la contraseña`;
      throw new Error(message);
    }

    return data;
  } catch (error) {
    console.error('Error en el servicio de resetPassword:', error);
    throw error;
  }
};

/**
 * Verificar si el token sigue válido
 */
export const verifyToken = async (token) => {
  try {
    const response = await fetch(`${API_URL}/verify-token`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Token inválido');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al verificar token:', error);
    throw error;
  }
};

/**
 * Cerrar sesión en el servidor
 * @param {number} userId - ID del usuario
 * @param {string} token - Token de autenticación
 */
export const logout = async (userId, token) => {
  try {
    const response = await fetch(`${API_URL}/logout/${userId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Error al cerrar sesión en el servidor');
    }

    return data;
  } catch (error) {
    console.error('Error al cerrar sesión en el servidor:', error);
    throw error;
  }
};